export default __webpack_public_path__ + "static/media/h_wdt_c_4.ae755011.mp3";